<template>
  <div
    v-if="totalPage > 1"
    class="ssr-pager">
    <div class="pager-box">
      <!-- 上一页按钮 -->
      <template v-if="ssr && !useALink">
        <NuxtLink
          v-if="currentPage > 1 || nowPage > 1"
          :class="['btn btn-prev', { disabled: nowPage === 1 }]"
          :to="`${link}${linkPath}${nowPage - 1}/${uriFormat}`"
          rel="nofollow">
          {{ $t('pagination.previousPage') }}
        </NuxtLink>
        <button
          v-else-if="currentPage === 1 || nowPage === 1"
          :class="['btn btn-prev', { disabled: nowPage === 1 }]"
          rel="nofollow"
          type="button"
          @click="prevPage">
          {{ $t('pagination.previousPage') }}
        </button>
      </template>
      <template v-else-if="ssr && useALink">
        <a
          v-if="currentPage > 1 || nowPage > 1"
          :class="['btn btn-prev', { disabled: nowPage === 1 }]"
          :href="
            nowPage - 1 === 1
              ? firstLink
                ? `${firstLink}${uriFormat}`
                : `${link}${linkPath}1/${uriFormat}`
              : `${link}${linkPath}${nowPage - 1}/${uriFormat}`
          "
          rel="nofollow">
          {{ $t('pagination.previousPage') }}
        </a>
        <button
          v-else-if="currentPage === 1 || nowPage === 1"
          :class="['btn btn-prev', { disabled: nowPage === 1 }]"
          type="button"
          @click="prevPage">
          {{ $t('pagination.previousPage') }}
        </button>
      </template>
      <template v-else-if="!ssr">
        <button
          :class="['btn btn-prev', { disabled: nowPage === 1 }]"
          type="button"
          @click="prevPage">
          {{ $t('pagination.previousPage') }}
        </button>
      </template>

      <!-- 页码列表 -->
      <div class="pager-ul">
        <!-- 第一页 -->
        <template v-if="ssr && !useALink && currentPage <= 5">
          <NuxtLink
            :key="1"
            :class="['number', { active: nowPage === 1 }]"
            :to="firstLink ? `${firstLink}${uriFormat}` : `${link}${linkPath}1/${uriFormat}`"
            rel="nofollow">
            1
          </NuxtLink>
        </template>
        <template v-else-if="ssr && useALink && currentPage <= 5">
          <a
            :class="['number', { active: nowPage === 1 }]"
            :href="
              nowPage === 1
                ? 'javascript:void(0)'
                : firstLink
                  ? `${firstLink}${uriFormat}`
                  : `${link}${linkPath}1/${uriFormat}`
            "
            rel="nofollow">
            1
          </a>
        </template>
        <template v-else-if="!ssr && currentPage <= 5">
          <span
            :class="['number', { active: nowPage === 1 }]"
            @click="changePage(1)">
            1
          </span>
        </template>

        <!-- 省略页码符号 -->
        <!--        <span-->
        <!--          class="number point point-prev"-->
        <!--          @click="jumpFivePage('prev')"-->
        <!--          v-if="totalPage > pagerCount && nowPage >= jumpNum"-->
        <!--        >-->
        <!--          ...-->
        <!--        </span>-->

        <!-- 第二页 -->
        <template v-if="ssr && !useALink">
          <NuxtLink
            v-if="(totalPage <= pagerCount || nowPage < jumpNum) && totalPage > 2"
            :key="2"
            :class="['number', { active: nowPage === 2 }]"
            :to="`${link}${linkPath}2/${uriFormat}`"
            rel="nofollow">
            2
          </NuxtLink>
        </template>
        <template v-else-if="ssr && useALink">
          <a
            v-if="(totalPage <= pagerCount || nowPage < jumpNum) && totalPage > 2"
            :class="['number', { active: nowPage === 2 }]"
            :href="nowPage === 2 ? 'javascript:void(0);' : `${link}${linkPath}2/${uriFormat}`"
            rel="nofollow">
            2
          </a>
        </template>
        <template v-else-if="!ssr">
          <span
            v-if="(totalPage <= pagerCount || nowPage < jumpNum) && totalPage > 2"
            :class="['number', { active: nowPage === 2 }]"
            @click="changePage(2)">
            2
          </span>
        </template>

        <!-- 中间页 -->
        <template v-if="ssr && !useALink">
          <NuxtLink
            v-for="i in pageList"
            :key="i"
            :class="['number', { active: nowPage === i }]"
            :to="`${link}${linkPath}${i}/${uriFormat}`"
            rel="nofollow">
            {{ i }}
          </NuxtLink>
        </template>
        <template v-else-if="ssr && useALink">
          <a
            v-for="i in pageList"
            :key="i"
            :class="['number', { active: nowPage === i }]"
            :href="nowPage === i ? 'javascript:void(0);' : `${link}${linkPath}${i}/${uriFormat}`"
            rel="nofollow">
            {{ i }}
          </a>
        </template>
        <template v-else-if="!ssr">
          <span
            v-for="i in pageList"
            :key="i"
            :class="['number', { active: nowPage === i }]"
            @click="changePage(i)">
            {{ i }}
          </span>
        </template>

        <!-- 倒数第二页 -->
        <template v-if="ssr && !useALink">
          <NuxtLink
            v-if="(totalPage <= pagerCount || nowPage >= totalPage - addNum - 1) && totalPage > 3"
            :class="['number', { active: nowPage === totalPage - 1 }]"
            :to="`${link}${linkPath}${totalPage - 1}/${uriFormat}`"
            rel="nofollow">
            {{ totalPage - 1 }}
          </NuxtLink>
        </template>
        <template v-else-if="ssr && useALink">
          <a
            v-if="(totalPage <= pagerCount || nowPage >= totalPage - addNum - 1) && totalPage > 3"
            :class="['number', { active: nowPage === totalPage - 1 }]"
            :href="
              nowPage === totalPage - 1
                ? 'javascript:void(0);'
                : `${link}${linkPath}${totalPage - 1}/${uriFormat}`
            "
            rel="nofollow">
            {{ totalPage - 1 }}
          </a>
        </template>
        <template v-else-if="!ssr">
          <span
            v-if="(totalPage <= pagerCount || nowPage >= totalPage - addNum - 1) && totalPage > 3"
            :class="['number', { active: nowPage === totalPage - 1 }]"
            @click="changePage(totalPage - 1)">
            {{ totalPage - 1 }}
          </span>
        </template>

        <!-- 尾部省略页码符号 -->
        <!--        <span-->
        <!--          class="number point point-next"-->
        <!--          @click="jumpFivePage('next')"-->
        <!--          v-if="totalPage > pagerCount && nowPage < totalPage - addNum - 1"-->
        <!--        >-->
        <!--          ...-->
        <!--        </span>-->

        <!-- 倒数第一页 -->
        <template v-if="ssr && !useALink && totalPage - currentPage <= 5">
          <NuxtLink
            v-if="totalPage > 1"
            :class="['number', { active: nowPage === totalPage }]"
            :to="`${link}${linkPath}${totalPage}/${uriFormat}`"
            rel="nofollow">
            {{ totalPage }}
          </NuxtLink>
        </template>
        <template v-else-if="ssr && useALink && totalPage - currentPage <= 5">
          <a
            v-if="totalPage > 1"
            :class="['number', { active: nowPage === totalPage }]"
            :href="
              nowPage === totalPage
                ? 'javascript:void(0);'
                : `${link}${linkPath}${totalPage}/${uriFormat}`
            "
            rel="nofollow">
            {{ totalPage }}
          </a>
        </template>
        <template v-else-if="!ssr && totalPage - currentPage <= 5">
          <span
            v-if="totalPage > 1"
            :class="['number', { active: nowPage === totalPage }]"
            @click="changePage(totalPage)">
            {{ totalPage }}
          </span>
        </template>
      </div>

      <!-- 下一页按钮 -->
      <template v-if="ssr && !useALink">
        <NuxtLink
          v-if="nowPage < totalPage"
          :class="['btn btn-next', { disabled: nowPage === totalPage }]"
          :to="`${link}${linkPath}${nowPage + 1}/${uriFormat}`"
          rel="nofollow">
          {{ $t('pagination.nextPage') }}
        </NuxtLink>
        <button
          v-else-if="nowPage >= totalPage"
          :class="['btn btn-next', { disabled: nowPage === totalPage }]"
          type="button"
          @click="nextPage">
          {{ $t('pagination.nextPage') }}
        </button>
      </template>
      <template v-else-if="ssr && useALink">
        <a
          v-if="nowPage < totalPage"
          :class="['btn btn-next', { disabled: nowPage === totalPage }]"
          :href="`${link}${linkPath}${nowPage + 1}/${uriFormat}`"
          rel="nofollow">
          {{ $t('pagination.nextPage') }}
        </a>
        <button
          v-else-if="nowPage >= totalPage"
          :class="['btn btn-next', { disabled: nowPage === totalPage }]"
          type="button"
          @click="nextPage">
          {{ $t('pagination.nextPage') }}
        </button>
      </template>
      <template v-else-if="!ssr">
        <button
          :class="['btn btn-next', { disabled: nowPage === totalPage }]"
          type="button"
          @click="nextPage">
          {{ $t('pagination.nextPage') }}
        </button>
      </template>

      <div class="pager-jump">
        {{ $t('pagination.goTo') }}
        <input
          v-model="redirectNum"
          :max="totalPage"
          class="jump-input"
          min="1"
          type="number"
          @blur="!confirmBtn && jumpPage"
          @change="jumpPage" />
        {{ $t('pagination.page') }}
      </div>
      <button
        v-if="confirmBtn"
        type="button"
        class="btn btn-jump">
        {{ $t('pagination.confirm') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import qs from 'qs'
  import _ from 'lodash'

  const props = defineProps({
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pagerCount: {
      type: Number,
      default: (val: any) => {
        if (!val || isNaN(val) || val < 5 || val > 21) return 9
        let num = 7
        for (let i = 5; i <= 21; i++) {
          if (i % 2 !== 0) {
            if (val >= i && val < i + 2) {
              num = i
            }
          }
        }
        return num
      }
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageCount: {
      type: Number,
      default: 0
    },
    firstLink: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    linkPath: {
      type: String,
      default: ''
    },
    useALink: {
      type: Boolean,
      default: false
    },
    ssr: {
      type: Boolean,
      default: true
    },
    confirmBtn: {
      type: Boolean,
      default: false
    }
  })

  const emit = defineEmits(['changePager', 'prev'])

  const nowPage = ref(props.currentPage)
  const redirectNum = ref(props.currentPage)
  const route = useRoute()
  const { t: $t } = useI18n()

  const totalPage = computed(() => {
    return props.pageCount > 0 ? props.pageCount : Math.ceil(props.total / props.pageSize)
  })

  const jumpNum = computed(() => {
    return (props.pagerCount + 3) / 2
  })

  const addNum = computed(() => {
    return (props.pagerCount - 3) / 2
  })

  const pageList = computed(() => {
    let arr: any[] = []
    if (totalPage.value <= 4) {
      return []
    } else if (totalPage.value > 4 && totalPage.value <= props.pagerCount + 1) {
      arr = Array.from(new Array(totalPage.value - 1).keys()).slice(3)
    } else if (totalPage.value > props.pagerCount + 1) {
      if (nowPage.value < jumpNum.value) {
        arr = Array.from(new Array(props.pagerCount).keys()).slice(3)
      } else if (
        nowPage.value >= jumpNum.value &&
        nowPage.value < totalPage.value - addNum.value - 1
      ) {
        const maxNum = nowPage.value + addNum.value
        arr = Array.from(new Array(maxNum + 1).keys()).slice(nowPage.value - addNum.value)
      } else if (nowPage.value >= totalPage.value - addNum.value - 1) {
        const maxNum = totalPage.value
        const reduceNum = addNum.value * 2 + 1
        arr = Array.from(new Array(maxNum - 1).keys()).slice(totalPage.value - reduceNum)
      }
    }
    return arr
  })

  const uriFormat = computed(() => {
    if (import.meta.client) {
      return location.search
    } else {
      if (!_.isEmpty(route.query)) {
        return '?' + qs.stringify(route.query)
      }
    }
    return ''
  })

  watch(
    () => props.currentPage,
    newval => {
      nowPage.value = newval
      redirectNum.value = newval
    }
  )

  const prevPage = () => {
    if (nowPage.value <= 1) return false
    nowPage.value -= 1
    redirectNum.value = nowPage.value
    emit('changePager', nowPage.value)
  }

  const changePage = (page: number) => {
    if (page > 0) {
      nowPage.value = page
      redirectNum.value = page
      emit('changePager', nowPage.value)
    }
  }

  const jumpPage = (page: any) => {
    const str = String(page.target.value)
    if (+str.charAt(0) >= 1) {
      const val = parseInt(str)
      if (val <= totalPage.value) {
        redirectNum.value = val
      } else {
        redirectNum.value = totalPage.value
      }
    } else {
      redirectNum.value = 1
    }
    nowPage.value = Number(redirectNum.value)
    emit('changePager', nowPage.value)
  }

  const nextPage = () => {
    if (nowPage.value >= totalPage.value) return false
    nowPage.value += 1
    redirectNum.value = nowPage.value
    emit('changePager', nowPage.value)
  }

  const jumpFivePage = (type: string) => {
    if (type === 'prev') {
      nowPage.value -= props.pagerCount - 2
      if (nowPage.value <= 1) nowPage.value = 1
    } else {
      nowPage.value += props.pagerCount - 2
      if (nowPage.value >= totalPage.value) nowPage.value = totalPage.value
    }
    redirectNum.value = nowPage.value
    emit('changePager', nowPage.value)
  }
</script>

<style lang="less" scoped>
  .ssr-pager {
    padding: 20px 0;
    text-align: center;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    font-size: 14px;
    color: #606266;

    .pager-box {
      display: inline-block;

      .btn {
        display: inline-block;
        border: none;
        background-color: #f4f4f5;
        height: 28px;
        line-height: 28px;
        border-radius: 2px;
        cursor: pointer;
        padding: 0 10px;
        color: #606266;

        &:hover {
          color: @app-color;
        }

        &.disabled {
          cursor: not-allowed;
          color: #c0c4cc;

          &:hover {
            color: #c0c4cc;
          }
        }
      }

      .pager-ul {
        display: inline-flex;
        margin: 0 4px;
        vertical-align: top;

        .number {
          display: inline-block;
          vertical-align: top;
          height: 28px;
          min-width: 30px;
          line-height: 28px;
          margin: 0 5px;
          box-sizing: border-box;
          text-align: center;
          background-color: #f4f4f5;
          color: #606266;
          border-radius: 2px;
          cursor: pointer;

          &.point {
            line-height: 20px;
            position: relative;

            &:hover {
              color: @app-color;

              &::before {
                content: '<<';
                position: absolute;
                min-width: 30px;
                height: 100%;
                left: 0;
                line-height: 28px;
                background-color: #f4f4f5;
              }

              &.point-next::before {
                content: '>>';
              }
            }
          }

          &.active {
            background-color: @app-color;
            color: #fff !important;

            &:hover {
              color: #fff;
              cursor: text;
            }
          }

          &:hover {
            color: @app-color;
          }
        }
      }

      .pager-jump {
        display: inline-block;
        margin: 0 10px 0 30px;

        .jump-input {
          width: 50px;
          -webkit-appearance: none;
          -moz-appearance: textfield;
          background-color: #fff;
          background-image: none;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          box-sizing: border-box;
          color: #606266;
          text-align: center;
          display: inline-block;
          font-size: inherit;
          height: 28px;
          padding: 0 3px;
          line-height: 28px;
          outline: 0;
          transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        }
      }
    }

    // 去掉input=number时的小箭头
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    button {
      outline: none;
    }

    a {
      text-decoration: none;
    }
  }
</style>
